/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Image, Space } from "antd";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { invoiceLineHeadView } from '../../../../../../config/constant';
import { TableCell, TableRow, Checkbox } from "@mui/material";
import { getColumnWidth, currencyFormat } from "../../../../../../helpers/utilities";
import { NavLink } from "react-router-dom";
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import { InvoiceLineForm } from "./InvoiceLineForm";
import { emptyValidation } from "../../../../../../helpers/validation";
import { gstCalculation } from "../../../../../../helpers/utilities";


export const InvoiceLinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, lines, loadMore, selected, handleClick, hsnApi, calculateLineTotal, lineSubmit, form, single } = props;
    const [lineId, setLineId] = useState('');
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('Add');
    const [view, setView] = useState(false);
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});

    const onEdit = (data, i, view = false) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        setLineForm(data);
        hsnApi('', data?.hsnId || '');
    }

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        setLineForm({
            includeGst: form?.includeGst,
        });
        hsnApi();
        setLineId('');
        setLineError({});
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let checkValidation = true;
        let emptyProductGst = emptyValidation('Product GST Code', lineForm?.productGstId, 'dropDown');
        let emptyHsn = emptyValidation('HSN', lineForm?.hsnId, 'dropDown');
        if ((lineForm?.includeGst && !emptyProductGst.isValid) || (lineForm?.includeGst && !emptyHsn.isValid)) {
            checkValidation = false;
        }
        let discountAgreeMents = true;
        let total = lineForm?.invoice_quantity * lineForm?.invoice_unitPrice;
        if (Math.abs(total) < Math.abs(lineForm?.discountCalcAmount)) {
            discountAgreeMents = false;
        }
        setLineError({});
        if (checkValidation && discountAgreeMents) {
            lineSubmit(lineForm, lineId);
            handleOpen();
        } else {
            setLineError({
                productGstId: lineForm?.includeGst && emptyProductGst?.errors ? emptyProductGst?.errors : false,
                hsnId: lineForm?.includeGst && emptyHsn?.errors ? emptyHsn?.errors : false,
                invoice_unitPrice: !discountAgreeMents ? 'Discount amount is greater than Line amount, please correct it.' : false,
            })
        }
    }

    const handleLineIncludeGst = (value) => {
        setLineError({
            ...lineError, productGstId: false
        });
        let data = {
            includeGst: value,
        };
        if (value) {
            if (lineForm?.productGst) {
                let percentage = lineForm?.productGst?.percentage;
                let details = {
                    percentage: percentage,
                    stateId: form?.stateId,
                    lineAmount: lineForm?.amount || ''
                };

                let gstCalc = gstCalculation({
                    ...form?.business,
                    priceIncludesTax: form?.priceIncludesTax || false
                }, details, form?.customer);
                data['cgstPercentage'] = parseFloat(gstCalc?.cgst || 0);
                data['sgstPercentage'] = parseFloat(gstCalc?.sgst || 0);
                data['igstPercentage'] = parseFloat(gstCalc?.igst || 0);
                data['cgst'] = parseFloat(gstCalc?.cgstAmount || 0);
                data['sgst'] = parseFloat(gstCalc?.sgstAmount || 0);
                data['igst'] = parseFloat(gstCalc?.igstAmount || 0);
                data['gstAmount'] = parseFloat(gstCalc.gAmount || 0);
            }
            setLineForm({
                ...lineForm, ...data
            })
        } else {
            setLineForm({
                ...lineForm,
                includeGst: value,
                gstAmount: 0,
                cgst: 0,
                sgst: 0,
                igst: 0,
                cgstAmount: 0,
                sgstAmount: 0, igstAmount: 0
            });
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'productGstId') {
                let d = {
                    ...lineForm,
                    [name]: e.id,
                    'productGst': e
                };
                setLineForm({ ...d, ...calculateLineTotal(d, form) });
            } else if (name === 'hsnId') {
                let d = {
                    ...lineForm,
                    [name]: e.id,
                    'hsn': e
                };
                setLineForm({ ...d, ...calculateLineTotal(d, form) });
            } else if (name === 'invoice_quantity') {
                let d = {
                    ...lineForm,
                    [name]: e,
                    'available_quantity': parseFloat(parseFloat(lineForm.duplicate_available_quantity) - parseFloat(e))
                };
                setLineForm({ ...d, ...calculateLineTotal(d, form) });
            } else {
                let d = {
                    ...lineForm,
                    [name]: e
                };
                setLineForm({ ...d, ...calculateLineTotal(d, form) });
            }
        } else {
            let d = {
                ...lineForm,
                [e.target.name]: e.target.value
            };
            setLineForm({ ...d, ...calculateLineTotal(d, form) });
        }
    }


    return (
        <>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    loadMore={true}
                    loadMoreContent={false}
                    heads={invoiceLineHeadView}
                    width={true}
                    component={
                        <>
                            {
                                !loadMore ? (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        <TableCell className={classes.textAlignCenter} colSpan={invoiceLineHeadView.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                    </TableRow>
                                ) : (
                                    <>
                                        {
                                            lines?.length > 0 ? lines.map((data, i) => (
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                    <TableCell style={{ width: 10 }}>

                                                        {
                                                            data?.duplicate_available_quantity === 0 ? <Checkbox checked={selected.find(e => e === data.id) ? true : false}
                                                                disabled={true} /> : <Checkbox checked={selected.find(e => e === data.id) ? true : false}
                                                                    onChange={(e) => handleClick(data)} />
                                                        }
                                                    </TableCell>
                                                    <TableCell style={{ width: 10 }}>{single ? data?.lineNumber : (i + 1)}</TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 1) }}><span style={{ width: getColumnWidth(invoiceLineHeadView, 1) }}>{data.product?.productId || '---'}</span></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 2) }}><NavLink style={{ width: getColumnWidth(invoiceLineHeadView, 2) }} onClick={() => onEdit(data, i, true)} to={"#"} className={clsx(classes.bold, classes.color)}><span className={classes.descEllipsis}>{data.description}</span></NavLink></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 3) }}><span style={{ width: getColumnWidth(invoiceLineHeadView, 3) }}>{data?.quantity || '---'}</span></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 4) }}><span style={{ width: getColumnWidth(invoiceLineHeadView, 4) }}>{data.unit?.name || '---'}</span></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 5) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(invoiceLineHeadView, 5) }}>{`₹ ${currencyFormat(data?.pricePerUnit || 0)}`}</span></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 6) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(invoiceLineHeadView, 6) }}>
                                                        {`₹ ${(data.discountAmount || data.discountPercent) ?
                                                            (data.quantity < 0 ?
                                                                currencyFormat((parseFloat(data?.discountAmount || 0) - parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))) :
                                                                currencyFormat((parseFloat(data?.discountAmount || 0) + parseFloat(((data.quantity * data.pricePerUnit) * data.discountPercent) / 100))))
                                                            : currencyFormat(0)}`}
                                                    </span>
                                                    </TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 7) }} className={classes.textAlignRight}><span style={{ width: getColumnWidth(invoiceLineHeadView, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 9) }}><span style={{ width: getColumnWidth(invoiceLineHeadView, 9) }}>{data?.available_quantity}</span></TableCell>
                                                    <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)} style={{ width: getColumnWidth(invoiceLineHeadView, 10) }}>
                                                        {/* <span style={{ width: getColumnWidth(invoiceLineHeadView, 10) }}>
                                                            {
                                                                selected.find(e => e === data.id) ? <TextField autoComplete='one-time-code'
                                                                    fullWidth
                                                                    type={'number'}
                                                                    className={clsx(classes.storeSalesLineQuantity, classes.storeSalesLinePrice)}
                                                                    value={data.invoice_quantity || ''}
                                                                    InputProps={{
                                                                        classes: {
                                                                            input: clsx(classes.textFieldColor, classes.textAlignCenter),
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        step: "any"
                                                                    }}
                                                                    id={idNamingConversion('Invoice Quantity', 'salesOrderLine', 'TextField')}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    InputLabelProps={{ className: classes.textAreaLableColorCustom }}
                                                                    onFocus={(e) => e.target.select()}
                                                                    onChange={(e) => {
                                                                        if (e.target.value === '' || parseFloat(e.target.value) < 0) {
                                                                            changeHandlerLine(data, 0, 'invoice_quantity');
                                                                        } else if (parseFloat(e.target.value) <= parseFloat(data.duplicate_available_quantity)) {
                                                                            changeHandlerLine(data, parseFloat(e.target.value), 'invoice_quantity');
                                                                        }
                                                                    }}
                                                                /> : data?.quantity
                                                            }
                                                        </span> */}
                                                        <span style={{ width: getColumnWidth(invoiceLineHeadView, 10) }}>{data?.invoice_quantity || ''}</span>
                                                    </TableCell>
                                                    <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignRight)} style={{ width: getColumnWidth(invoiceLineHeadView, 10) }}>
                                                        <span style={{ width: getColumnWidth(invoiceLineHeadView, 10) }}>{data?.invoice_unitPrice || ''}
                                                            {/* {
                                                                selected.find(e => e === data.id) ? <TextField autoComplete='one-time-code'
                                                                    fullWidth
                                                                    type={'number'}
                                                                    className={clsx(classes.storeSalesLineQuantity, classes.storeSalesLinePrice)}
                                                                    value={data?.invoice_unitPrice || ''}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                                        classes: {
                                                                            input: clsx(classes.textFieldColor, classes.textAlignRight),
                                                                        }
                                                                    }}
                                                                    inputProps={{
                                                                        step: "any"
                                                                    }}
                                                                    id={idNamingConversion('Invoice Unit Price', 'salesOrderLine', 'TextField')}
                                                                    onWheel={(e) => e.target.blur()}
                                                                    InputLabelProps={{ className: classes.textAreaLableColorCustom }}
                                                                    onFocus={(e) => e.target.select()}
                                                                    onChange={(e) => {
                                                                        changeHandlerLine(data, e.target.value, 'invoice_unitPrice');
                                                                    }}
                                                                /> : `₹ ${currencyFormat(data?.pricePerUnit || 0)}`
                                                            } */}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 11) }} className={classes.textAlignRight}>
                                                        <span style={{ width: getColumnWidth(invoiceLineHeadView, 11) }}>
                                                            {`₹ ${currencyFormat(data?.invoice_netAmount || 0)}`}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 12) }}><span style={{ width: getColumnWidth(invoiceLineHeadView, 12) }}>
                                                        {data.productGst?.code || '---'}
                                                    </span></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(invoiceLineHeadView, 13) }} className={classes.textAlignRight}>
                                                        <span style={{ width: getColumnWidth(invoiceLineHeadView, 13) }}>
                                                            {
                                                                selected.find(e => e === data.id) ? `₹ ${currencyFormat(data?.gstAmount || 0)}` : '---'
                                                            }
                                                        </span></TableCell>
                                                    <TableCell className={classes.textAlignRight}>
                                                        <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                            <NavLink to={"#"} onClick={() => onEdit(data, i, true)}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                            {
                                                                data?.duplicate_available_quantity > 0 && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                                    <Image
                                                                        src={EditIcon}
                                                                        preview={false}
                                                                    />
                                                                </NavLink>
                                                            }
                                                        </Space>
                                                    </TableCell>
                                                </TableRow>
                                            )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ textAlign: "center" }} colSpan={invoiceLineHeadView.length}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your Delivery'}</p>
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </>
                                )
                            }
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Order Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <InvoiceLineForm {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        lineError={lineError}
                        handleEdit={(v) => setView(v)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        handleLineIncludeGst={(v) => handleLineIncludeGst(v)}

                    />
                }
            />
        </>
    )
})